(() => {
  const BODY_CLASS = 'lw-product-pilot-template';
  const EVENT_NAME = 'shopify:product:select';

  const ENDCAP_ERROR_MESSAGE =
    'Bitte wählen Sie eine Endkappen-Farbe aus.';

  const ENCODED_PERSONALIZATION_SUFFIX =
    ' | PERSONALISIERT';

  const isEncodedPersonalizationValue = (
    value
  ) =>
    /\s*\|\s*personalisiert\s*$/i.test(
      String(value || '')
    );

  const stripEncodedPersonalizationValue = (
    value
  ) =>
    String(value || '')
      .replace(
        /\s*\|\s*personalisiert\s*$/i,
        ''
      )
      .trim();

  let userHasSelectedVariant = false;
  let currentBaseNetPrice = null;

  const normalize = (value) =>
    (value || '')
      .trim()
      .toLocaleLowerCase('de-DE');

  const isQuantityOptionName = (value) => {
    const text = normalize(value);

    return (
      text.includes('set') ||
      text.includes('menge') ||
      text.includes('stückzahl') ||
      text.includes('stueckzahl')
    );
  };

  const isPrintOptionName = (value) => {
    const text = normalize(value);

    return text.includes('druck');
  };

  const isPersonalizationOptionName = (value) =>
    normalize(value).includes('personalis');

  const isPositivePersonalizationValue = (value) => {
    const text = normalize(value);

    return (
      text === 'ja' ||
      text === 'mit personalisierung' ||
      (
        text.includes('mit') &&
        text.includes('personalis') &&
        !text.includes('ohne')
      )
    );
  };

  const isNegativePersonalizationValue = (value) => {
    const text = normalize(value);

    return (
      text === 'nein' ||
      text === 'ohne personalisierung' ||
      text.includes('ohne personalis')
    );
  };


  const BOAT_FONT_MEDIA_TOKENS = {
    festboot: {
      'pacifico': '3__14',
      'merienda one': '4__10',
      'frutiger': '5__10',
      'dancing script': '6__7',
      'baloo bhai': '10__9',
      'days one': '7__15',
      'anton': '11__9',
      'chewy': '8__10',
      'bree serif': '9__11',
      'alfa slab one': '12__5',
    },
    schlauchboot: {
      'alfa slab one': '12__6',
      'anton': '11__10',
      'baloo bhai': '10__11',
      'bree serif': '9__12',
      'days one': '7__16',
      'frutiger': '5__11',
      'merienda one': '4__11',
      'chewy': '8__11',
      'dancing script': '6__9',
      'pacifico': '3__15',
    },
  };

  const getBoatFamily = () => {
    const box = document.querySelector(
      '[data-lw-personalization]'
    );

    const family = normalize(
      box?.dataset.lwBoatFamily || ''
    );

    return Object.prototype.hasOwnProperty.call(
      BOAT_FONT_MEDIA_TOKENS,
      family
    )
      ? family
      : '';
  };

  const isFontOptionName = (value) => {
    const text = normalize(value);

    return (
      text.includes('schriftart') ||
      text === 'schrift' ||
      text.includes('font')
    );
  };

  const getSelectedFontValue = () => {
    const picker = document.querySelector(
      '.product-information variant-picker'
    );

    if (!picker) {
      return '';
    }

    const checkedInput = Array.from(
      picker.querySelectorAll(
        'input[type="radio"][data-option-name]:checked'
      )
    ).find((input) =>
      isFontOptionName(
        input.getAttribute('data-option-name') || ''
      )
    );

    if (checkedInput instanceof HTMLInputElement) {
      return String(checkedInput.value || '').trim();
    }

    const selectedOption = Array.from(
      picker.querySelectorAll(
        'select.variant-option__select option:checked[data-option-name]'
      )
    ).find((option) =>
      isFontOptionName(
        option.getAttribute('data-option-name') || ''
      )
    );

    return selectedOption instanceof HTMLOptionElement
      ? String(selectedOption.value || '').trim()
      : '';
  };

  const getSlideImageSourceText = (slide) => {
    if (!(slide instanceof Element)) {
      return '';
    }

    const image = slide.querySelector('img');

    if (!(image instanceof HTMLImageElement)) {
      return '';
    }

    const raw = [
      image.currentSrc,
      image.getAttribute('src'),
      image.getAttribute('srcset'),
    ]
      .filter(Boolean)
      .join(' ');

    try {
      return decodeURIComponent(raw).toLowerCase();
    } catch (error) {
      return raw.toLowerCase();
    }
  };

  const showBoatFontMedia = (fontValue) => {
    const family = getBoatFamily();

    if (!family) {
      return false;
    }

    const token =
      BOAT_FONT_MEDIA_TOKENS[family]?.[
        normalize(fontValue)
      ];

    if (!token) {
      return false;
    }

    const gallery = document.querySelector(
      '.product-information media-gallery'
    );

    if (!(gallery instanceof HTMLElement)) {
      return false;
    }

    const slideshow =
      gallery.slideshow ||
      gallery.querySelector('slideshow-component');

    const slides = Array.from(
      gallery.querySelectorAll('slideshow-slide')
    );

    const index = slides.findIndex((slide) =>
      getSlideImageSourceText(slide).includes(token)
    );

    if (index < 0) {
      return false;
    }

    if (
      slideshow &&
      typeof slideshow.select === 'function'
    ) {
      slideshow.select(index, undefined, {
        animate: false,
      });

      return true;
    }

    const thumbnails = Array.from(
      gallery.querySelectorAll(
        '.slideshow-controls__thumbnail'
      )
    );

    const thumbnail = thumbnails[index];

    if (thumbnail instanceof HTMLButtonElement) {
      thumbnail.click();
      return true;
    }

    return false;
  };

  const syncBoatFontMedia = () => {
    const fontValue = getSelectedFontValue();

    if (!fontValue) {
      return;
    }

    showBoatFontMedia(fontValue);
  };

  const moneyFormatter = (currency) => {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'de-DE',
        {
          style: 'currency',
          currency: currency || 'EUR',
        }
      );
    } catch (error) {
      return new Intl.NumberFormat(
        'de-DE',
        {
          style: 'currency',
          currency: 'EUR',
        }
      );
    }
  };

  const getPricingData = () => {
    const script =
      document.querySelector(
        '[data-lw-variant-prices]'
      );

    if (!script) {
      return null;
    }

    try {
      return JSON.parse(
        script.textContent || '{}'
      );
    } catch (error) {
      console.warn(
        'LW Produkt: Variantendaten konnten nicht gelesen werden.',
        error
      );

      return null;
    }
  };

  const getPriceContext = () =>
    document.querySelector(
      '[data-lw-price-context]'
    );

  const getCurrentVariantId = () => {
    const variantIdInput =
      document.querySelector(
        '.product-information product-form-component input[name="id"]'
      );

    return variantIdInput instanceof HTMLInputElement
      ? String(variantIdInput.value || '')
      : '';
  };

  const getCurrentVariantData = () => {
    const data = getPricingData();

    if (
      !data ||
      !Array.isArray(data.variants)
    ) {
      return null;
    }

    const variantId = getCurrentVariantId();

    if (!variantId) {
      return null;
    }

    return (
      data.variants.find(
        (variant) =>
          String(variant.id) === variantId
      ) || null
    );
  };

  const getPersonalizationVariantContext = () => {
    const data = getPricingData();

    if (
      !data ||
      !Array.isArray(data.optionNames) ||
      !Array.isArray(data.variants)
    ) {
      return null;
    }

    const nativeOptionIndex =
      data.optionNames.findIndex(
        (name) =>
          isPersonalizationOptionName(name)
      );

    if (nativeOptionIndex >= 0) {
      const values = Array.from(
        new Set(
          data.variants
            .map((variant) =>
              Array.isArray(variant.options)
                ? variant.options[nativeOptionIndex]
                : null
            )
            .filter(Boolean)
        )
      );

      const positiveValue =
        values.find(
          isPositivePersonalizationValue
        );

      const negativeValue =
        values.find(
          isNegativePersonalizationValue
        );

      if (
        positiveValue &&
        negativeValue
      ) {
        return {
          type: 'native',
          data,
          optionIndex:
            nativeOptionIndex,
          values,
          positiveValue,
          negativeValue,
        };
      }
    }

    for (
      let optionIndex = 0;
      optionIndex <
      data.optionNames.length;
      optionIndex += 1
    ) {
      const values = Array.from(
        new Set(
          data.variants
            .map((variant) =>
              Array.isArray(variant.options)
                ? variant.options[optionIndex]
                : null
            )
            .filter(Boolean)
        )
      );

      const encodedValues =
        values.filter(
          isEncodedPersonalizationValue
        );

      if (!encodedValues.length) {
        continue;
      }

      const baseValues =
        values.filter(
          (value) =>
            !isEncodedPersonalizationValue(
              value
            )
        );

      const hasCompletePair =
        encodedValues.some(
          (encodedValue) => {
            const baseValue =
              stripEncodedPersonalizationValue(
                encodedValue
              );

            return baseValues.some(
              (candidate) =>
                normalize(candidate) ===
                normalize(baseValue)
            );
          }
        );

      if (!hasCompletePair) {
        continue;
      }

      return {
        type: 'encoded',
        data,
        optionIndex,
        values,
      };
    }

    return null;
  };

  const usesPersonalizationVariants = () =>
    Boolean(
      getPersonalizationVariantContext()
    );

  const getTargetPersonalizationValue = (
    context,
    currentValue,
    enabled
  ) => {
    if (!context) {
      return null;
    }

    if (context.type === 'native') {
      return enabled
        ? context.positiveValue
        : context.negativeValue;
    }

    if (context.type !== 'encoded') {
      return null;
    }

    const baseValue =
      stripEncodedPersonalizationValue(
        currentValue
      );

    return (
      context.values.find(
        (candidate) => {
          const candidateIsEncoded =
            isEncodedPersonalizationValue(
              candidate
            );

          if (
            enabled !==
            candidateIsEncoded
          ) {
            return false;
          }

          return (
            normalize(
              stripEncodedPersonalizationValue(
                candidate
              )
            ) ===
            normalize(baseValue)
          );
        }
      ) || null
    );
  };

  const findPairedPersonalizationVariant = (
    enabled,
    currentVariant =
      getCurrentVariantData()
  ) => {
    const context =
      getPersonalizationVariantContext();

    if (
      !context ||
      !currentVariant ||
      !Array.isArray(currentVariant.options)
    ) {
      return null;
    }

    const currentValue =
      currentVariant.options[
        context.optionIndex
      ];

    const targetValue =
      getTargetPersonalizationValue(
        context,
        currentValue,
        enabled
      );

    if (!targetValue) {
      return null;
    }

    const targetOptions =
      [...currentVariant.options];

    targetOptions[
      context.optionIndex
    ] = targetValue;

    return (
      context.data.variants.find(
        (variant) =>
          Array.isArray(variant.options) &&
          variant.options.length ===
            targetOptions.length &&
          variant.options.every(
            (optionValue, index) =>
              optionValue ===
              targetOptions[index]
          )
      ) || null
    );
  };

  const getSelectedPersonalizationState = () => {
    const context =
      getPersonalizationVariantContext();

    if (!context) {
      return null;
    }

    const variant =
      getCurrentVariantData();

    if (
      !variant ||
      !Array.isArray(variant.options)
    ) {
      return null;
    }

    const value =
      variant.options[
        context.optionIndex
      ];

    if (context.type === 'encoded') {
      return isEncodedPersonalizationValue(
        value
      );
    }

    if (
      isPositivePersonalizationValue(value)
    ) {
      return true;
    }

    if (
      isNegativePersonalizationValue(value)
    ) {
      return false;
    }

    return null;
  };

  const toNetPrice = (storedPrice) => {
    const priceContext =
      getPriceContext();

    const numericPrice =
      Number(storedPrice);

    if (
      !Number.isFinite(
        numericPrice
      )
    ) {
      return null;
    }

    const basis =
      normalize(
        priceContext?.dataset.priceBasis ||
        'net'
      );

    if (
      basis ===
      'net'
    ) {
      return numericPrice;
    }

    const taxRate =
      Number(
        priceContext?.dataset.taxRate ||
        '19'
      );

    return (
      numericPrice /
      (1 + taxRate / 100)
    );
  };

  const getVariantOptionGroups = () => {
    const picker =
      document.querySelector(
        '.product-information variant-picker'
      );

    if (!picker) {
      return [];
    }

    return Array.from(
      picker.querySelectorAll(
        'fieldset.variant-option'
      )
    );
  };

  const stripEncodedTextNodes = (
    root
  ) => {
    if (!(root instanceof Element)) {
      return;
    }

    const walker =
      document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT
      );

    const nodes = [];

    while (walker.nextNode()) {
      nodes.push(
        walker.currentNode
      );
    }

    nodes.forEach(
      (node) => {
        node.nodeValue =
          String(
            node.nodeValue || ''
          ).replace(
            /\s*\|\s*PERSONALISIERT/gi,
            ''
          );
      }
    );
  };

  const getEncodedControlContainer = (
    input,
    group
  ) => {
    if (
      !(
        input instanceof
        HTMLInputElement
      )
    ) {
      return null;
    }

    const nestedLabel =
      input.closest('label');

    if (
      nestedLabel instanceof
      HTMLElement
    ) {
      return nestedLabel;
    }

    const inputId =
      String(input.id || '').trim();

    if (inputId) {
      const linkedLabel =
        Array.from(
          group.querySelectorAll('label')
        ).find(
          (label) =>
            String(
              label.getAttribute('for') || ''
            ) === inputId
        );

      if (
        linkedLabel instanceof
        HTMLElement
      ) {
        return linkedLabel;
      }
    }

    const buttonLabel =
      input.closest(
        '.variant-option__button-label'
      );

    if (
      buttonLabel instanceof
      HTMLElement
    ) {
      return buttonLabel;
    }

    const optionValueWrapper =
      input.closest(
        '[data-option-value]'
      );

    if (
      optionValueWrapper instanceof
      HTMLElement
    ) {
      return optionValueWrapper;
    }

    const listItem =
      input.closest('li');

    if (
      listItem instanceof
      HTMLElement
    ) {
      return listItem;
    }

    return (
      input.parentElement instanceof
      HTMLElement
        ? input.parentElement
        : null
    );
  };

  const hideEncodedTechnicalControl = (
    input,
    group
  ) => {
    if (
      !(
        input instanceof
        HTMLInputElement
      )
    ) {
      return;
    }

    const container =
      getEncodedControlContainer(
        input,
        group
      );

    if (
      container instanceof
      HTMLElement
    ) {
      stripEncodedTextNodes(
        container
      );

      container.hidden = true;

      container.style.setProperty(
        'display',
        'none',
        'important'
      );

      container.setAttribute(
        'aria-hidden',
        'true'
      );
    }

    input.tabIndex = -1;
    input.setAttribute(
      'aria-hidden',
      'true'
    );
  };

  const showEncodedBaseControl = (
    input,
    group
  ) => {
    if (
      !(
        input instanceof
        HTMLInputElement
      )
    ) {
      return;
    }

    const container =
      getEncodedControlContainer(
        input,
        group
      );

    if (
      container instanceof
      HTMLElement
    ) {
      stripEncodedTextNodes(
        container
      );

      container.hidden = false;

      container.style.removeProperty(
        'display'
      );

      container.removeAttribute(
        'aria-hidden'
      );
    }

    input.removeAttribute(
      'aria-hidden'
    );

    if (input.tabIndex < 0) {
      input.removeAttribute(
        'tabindex'
      );
    }
  };

  const updateEncodedPersonalizationControls = (
    enabled =
      getSelectedPersonalizationState() ===
      true
  ) => {
    const context =
      getPersonalizationVariantContext();

    if (
      !context ||
      context.type !== 'encoded'
    ) {
      return;
    }

    const groups =
      getVariantOptionGroups();

    const group =
      groups[
        context.optionIndex
      ];

    if (!group) {
      return;
    }

    const encodedBaseValues =
      new Set(
        context.values
          .filter(
            isEncodedPersonalizationValue
          )
          .map(
            (value) =>
              normalize(
                stripEncodedPersonalizationValue(
                  value
                )
              )
          )
      );

    group
      .querySelectorAll(
        'input'
      )
      .forEach(
        (input) => {
          if (
            !(
              input instanceof
              HTMLInputElement
            )
          ) {
            return;
          }

          const value =
            String(input.value || '');

          if (!value) {
            return;
          }

          const baseKey =
            normalize(
              stripEncodedPersonalizationValue(
                value
              )
            );

          if (
            !encodedBaseValues.has(
              baseKey
            )
          ) {
            return;
          }

          if (
            isEncodedPersonalizationValue(
              value
            )
          ) {
            hideEncodedTechnicalControl(
              input,
              group
            );
          } else {
            showEncodedBaseControl(
              input,
              group
            );
          }
        }
      );

    group
      .querySelectorAll(
        'select'
      )
      .forEach(
        (select) => {
          if (
            !(
              select instanceof
              HTMLSelectElement
            )
          ) {
            return;
          }

          Array.from(
            select.options
          ).forEach(
            (option) => {
              const value =
                String(
                  option.value || ''
                );

              const baseKey =
                normalize(
                  stripEncodedPersonalizationValue(
                    value
                  )
                );

              if (
                !encodedBaseValues.has(
                  baseKey
                )
              ) {
                return;
              }

              option.textContent =
                stripEncodedPersonalizationValue(
                  option.textContent
                );

              option.hidden =
                isEncodedPersonalizationValue(
                  value
                );
            }
          );
        }
      );

    group
      .querySelectorAll(
        '.variant-option__button-label'
      )
      .forEach(
        (label) =>
          stripEncodedTextNodes(
            label
          )
      );
  };

  const classifyVariantFields = () => {
    const picker =
      document.querySelector(
        '.product-information variant-picker'
      );

    if (!picker) {
      return;
    }

    picker
      .querySelectorAll(
        'fieldset.variant-option'
      )
      .forEach(
        (fieldset) => {
          const legend =
            fieldset.querySelector(
              'legend'
            );

          const text =
            normalize(
              legend?.textContent
            );

          fieldset.classList.remove(
            'lw-set-fieldset',
            'lw-personalization-fieldset',
            'lw-print-fieldset'
          );

          if (
            isQuantityOptionName(
              text
            )
          ) {
            fieldset.classList.add(
              'lw-set-fieldset'
            );

            if (legend) {
              legend.textContent =
                'Menge wählen';
            }
          }

          if (
            isPersonalizationOptionName(
              text
            )
          ) {
            fieldset.classList.add(
              'lw-personalization-fieldset'
            );

            if (legend) {
              legend.textContent =
                'Personalisierung';
            }
          }

          if (
            isPrintOptionName(
              text
            )
          ) {
            fieldset.classList.add(
              'lw-print-fieldset'
            );
          }
        }
      );

    updateEncodedPersonalizationControls();
  };

  const enhanceSetCards = () => {
    const data =
      getPricingData();

    const fieldset =
      document.querySelector(
        '.product-information .lw-set-fieldset'
      );

    if (
      !data ||
      !fieldset ||
      !Array.isArray(
        data.optionNames
      ) ||
      !Array.isArray(
        data.variants
      )
    ) {
      return;
    }

    const quantityIndex =
      data.optionNames.findIndex(
        (name) =>
          isQuantityOptionName(
            name
          )
      );

    if (
      quantityIndex <
      0
    ) {
      return;
    }

    const priceContext =
      getPriceContext();

    const currency =
      priceContext?.dataset.currency ||
      'EUR';

    const format =
      moneyFormatter(
        currency
      );

    fieldset
      .querySelectorAll(
        '.variant-option__button-label'
      )
      .forEach(
        (label) => {
          label
            .querySelectorAll(
              '.lw-pilot-set-price, .lw-pilot-set-unit'
            )
            .forEach(
              (node) =>
                node.remove()
            );

          const input =
            label.querySelector(
              'input'
            );

          if (
            !(
              input instanceof
              HTMLInputElement
            )
          ) {
            return;
          }

          const optionValue =
            input.value;

          const quantityMatch =
            optionValue.match(
              /\d+/
            );

          const setQuantity =
            quantityMatch
              ? Number(
                  quantityMatch[0]
                )
              : 0;

          const matches =
            data.variants.filter(
              (variant) => {
                return (
                  Array.isArray(
                    variant.options
                  ) &&
                  variant.options[
                    quantityIndex
                  ] ===
                    optionValue
                );
              }
            );

          if (
            !matches.length
          ) {
            return;
          }

          const availableMatches =
            matches.filter(
              (variant) =>
                variant.available !==
                false
            );

          const candidates =
            availableMatches.length
              ? availableMatches
              : matches;

          const storedPrice =
            Math.min(
              ...candidates
                .map(
                  (variant) =>
                    Number(
                      variant.price
                    )
                )
                .filter(
                  Number.isFinite
                )
            );

          const netPrice =
            toNetPrice(
              storedPrice
            );

          if (
            !Number.isFinite(
              netPrice
            )
          ) {
            return;
          }

          const price =
            document.createElement(
              'span'
            );

          price.className =
            'lw-pilot-set-price';

          price.textContent =
            format.format(
              netPrice
            );

          const unit =
            document.createElement(
              'span'
            );

          unit.className =
            'lw-pilot-set-unit';

          unit.textContent =
            setQuantity > 0
              ? `${format.format(
                  netPrice /
                  setQuantity
                )} netto / Stück`
              : '';

          label.append(
            price,
            unit
          );
        }
      );
  };

  const getPersonalizationBox = () =>
    document.querySelector(
      '[data-lw-personalization]'
    );

  const getPersonalizationFields = (
    box
  ) =>
    box?.querySelector(
      '[data-lw-personalization-fields]'
    ) || null;

  const getPersonalizationSurcharge = () => {
    // Seit Lauf 161 steckt der Aufschlag immer im Preis der echten
    // personalisierten Shopify-Variante. Keine optische Doppelberechnung.
    return 0;
  };

  const getPersonalizationSurchargeAmount = () => {
    const box =
      getPersonalizationBox();

    // Personalisierung "inklusive" darf niemals einen Preisaufschlag erben.
    // Das gilt auch dann, wenn alte Varianten-/Fallbackdaten noch 3,50 EUR enthalten.
    if (
      box?.dataset
        .lwPersonalizationRequiredIncluded ===
      'true'
    ) {
      return 0;
    }

    const currentVariant =
      getCurrentVariantData();

    const selectedState =
      getSelectedPersonalizationState();

    if (
      currentVariant &&
      selectedState !== null
    ) {
      const baseVariant =
        selectedState
          ? findPairedPersonalizationVariant(
              false,
              currentVariant
            )
          : currentVariant;

      const personalizedVariant =
        selectedState
          ? currentVariant
          : findPairedPersonalizationVariant(
              true,
              currentVariant
            );

      if (
        baseVariant &&
        personalizedVariant
      ) {
        const basePrice =
          toNetPrice(
            baseVariant.price
          );

        const personalizedPrice =
          toNetPrice(
            personalizedVariant.price
          );

        const difference =
          personalizedPrice -
          basePrice;

        if (
          Number.isFinite(
            difference
          ) &&
          difference >= 0
        ) {
          return difference;
        }
      }
    }

    const fallbackCents =
      Number(
        box?.dataset
          .lwPersonalizationPriceCents ||
        '350'
      );

    return Number.isFinite(
      fallbackCents
    )
      ? fallbackCents / 100
      : 3.5;
  };

  const updatePersonalizationSurchargeDisplay = () => {
    const box =
      getPersonalizationBox();

    if (!box) {
      return;
    }

    const surcharge =
      getPersonalizationSurchargeAmount();

    if (
      !Number.isFinite(
        surcharge
      )
    ) {
      return;
    }

    const currency =
      getPriceContext()
        ?.dataset.currency ||
      'EUR';

    const formatted =
      moneyFormatter(
        currency
      ).format(
        surcharge
      );

    box.dataset
      .lwPersonalizationPriceCents =
        String(
          Math.round(
            surcharge * 100
          )
        );

    box.dataset
      .lwPersonalizationPriceLabel =
        formatted;

    const priceLabel =
      box.querySelector(
        '.lw-personalization-toggle__price'
      );

    if (priceLabel) {
      priceLabel.textContent =
        `+${formatted}`;
    }

    const marker =
      box.querySelector(
        '[data-lw-personalization-marker]'
      );

    const personalizationRequiredIncluded =
      box.dataset
        .lwPersonalizationRequiredIncluded ===
      'true';

    if (personalizationRequiredIncluded) {
      box.dataset.lwPersonalizationPriceCents = '0';
      box.dataset.lwPersonalizationPriceLabel = formatted;
    }

    if (
      marker instanceof
      HTMLInputElement
    ) {
      marker.value =
        personalizationRequiredIncluded
          ? 'Ja (im Preis enthalten)'
          : `Ja (+${formatted})`;
    }

    const priceNote =
      box.querySelector(
        '[data-lw-personalization-price-note]'
      );

    if (priceNote) {
      priceNote.textContent =
        `Personalisierungsaufschlag: +${formatted} netto je bestelltem Stück.`;
    }
  };

  const setPersonalizationControlsEnabled = (
    box,
    enabled
  ) => {
    box
      .querySelectorAll(
        '[data-lw-personalization-input]'
      )
      .forEach(
        (control) => {
          if (
            'disabled' in
            control
          ) {
            control.disabled =
              !enabled;
          }
        }
      );
  };

  const clearPersonalizationFields = (
    box
  ) => {
    box
      .querySelectorAll(
        '[data-lw-personalization-input]'
      )
      .forEach(
        (control) => {
          if (
            !(
              control instanceof
              HTMLInputElement ||
              control instanceof
              HTMLTextAreaElement ||
              control instanceof
              HTMLSelectElement
            )
          ) {
            return;
          }

          if (
            control.matches(
              '[data-lw-personalization-marker]'
            )
          ) {
            return;
          }

          if (
            control instanceof
            HTMLInputElement &&
            control.type === 'file'
          ) {
            control.value =
              '';

            return;
          }

          if (
            control instanceof
            HTMLSelectElement
          ) {
            control.selectedIndex =
              0;

            control.setCustomValidity(
              ''
            );

            control.setAttribute(
              'aria-invalid',
              'false'
            );

            return;
          }

          if (
            control instanceof
            HTMLInputElement &&
            (
              control.type === 'checkbox' ||
              control.type === 'radio'
            )
          ) {
            control.checked =
              false;

            return;
          }

          control.value =
            '';
        }
      );

    const error =
      getEndcapError();

    if (error) {
      error.hidden =
        true;
    }
  };

  const findPersonalizationOptionControl = (
    value,
    optionIndex
  ) => {
    const groups =
      getVariantOptionGroups();

    const group =
      groups[
        optionIndex
      ];

    if (!group) {
      return null;
    }

    const normalizedValue =
      normalize(value);

    const input =
      Array.from(
        group.querySelectorAll(
          'input'
        )
      ).find(
        (candidate) =>
          candidate instanceof
            HTMLInputElement &&
          normalize(
            candidate.value
          ) ===
            normalizedValue
      );

    if (
      input instanceof
      HTMLInputElement
    ) {
      return input;
    }

    const select =
      group.querySelector(
        'select'
      );

    if (
      select instanceof
      HTMLSelectElement
    ) {
      const option =
        Array.from(
          select.options
        ).find(
          (candidate) =>
            normalize(
              candidate.value
            ) ===
              normalizedValue
        );

      if (option) {
        return {
          select,
          value:
            option.value,
        };
      }
    }

    return null;
  };

  const selectPersonalizationVariant = (
    enabled
  ) => {
    const context =
      getPersonalizationVariantContext();

    const currentVariant =
      getCurrentVariantData();

    if (
      !context ||
      !currentVariant ||
      !Array.isArray(
        currentVariant.options
      )
    ) {
      return false;
    }

    const targetVariant =
      findPairedPersonalizationVariant(
        enabled,
        currentVariant
      );

    if (!targetVariant) {
      console.warn(
        'LW Produkt: Passende Personalisierungsvariante wurde nicht gefunden.',
        {
          enabled,
          currentVariant,
          architecture:
            context.type,
        }
      );

      return false;
    }

    const currentSelectedState =
      getSelectedPersonalizationState();

    if (
      currentSelectedState === enabled &&
      String(
        targetVariant.id
      ) ===
        getCurrentVariantId()
    ) {
      updateEncodedPersonalizationControls(
        enabled
      );

      return true;
    }

    const targetValue =
      targetVariant.options[
        context.optionIndex
      ];

    const control =
      findPersonalizationOptionControl(
        targetValue,
        context.optionIndex
      );

    if (
      control instanceof
      HTMLInputElement
    ) {
      if (!control.checked) {
        control.click();
      }

      updateEncodedPersonalizationControls(
        enabled
      );

      return true;
    }

    if (
      control &&
      control.select instanceof
        HTMLSelectElement
    ) {
      if (
        control.select.value !==
        control.value
      ) {
        control.select.value =
          control.value;

        control.select.dispatchEvent(
          new Event('change', {
            bubbles: true,
          })
        );
      }

      updateEncodedPersonalizationControls(
        enabled
      );

      return true;
    }

    console.warn(
      'LW Produkt: Personalisierungs-Steuerelement wurde nicht gefunden.',
      {
        targetValue,
        optionIndex:
          context.optionIndex,
        architecture:
          context.type,
      }
    );

    return false;
  };

  const setLegacyPersonalizationChoice = (
    box,
    enabled
  ) => {
    if (
      usesPersonalizationVariants()
    ) {
      return;
    }

    const fieldset =
      document.querySelector(
        '.product-information .lw-personalization-fieldset'
      );

    if (!fieldset) {
      return;
    }

    const inputs =
      Array.from(
        fieldset.querySelectorAll(
          'input'
        )
      ).filter(
        (input) =>
          input instanceof
          HTMLInputElement
      );

    if (!inputs.length) {
      return;
    }

    const positive =
      normalize(
        box.dataset
          .positiveValue ||
        'Ja'
      );

    const positiveInput =
      inputs.find(
        (input) =>
          normalize(
            input.value
          ) ===
          positive
      );

    if (
      enabled &&
      positiveInput instanceof
        HTMLInputElement &&
      !positiveInput.checked
    ) {
      positiveInput.click();

      return;
    }

    if (!enabled) {
      const checked =
        inputs.find(
          (input) =>
            input.checked
        );

      if (
        checked &&
        normalize(
          checked.value
        ) !==
          positive
      ) {
        return;
      }

      const negativeInput =
        inputs.find(
          (input) => {
            const value =
              normalize(
                input.value
              );

            return (
              value !==
                positive &&
              (
                value === 'nein' ||
                value.includes(
                  'ohne'
                )
              )
            );
          }
        ) ||
        inputs.find(
          (input) =>
            normalize(
              input.value
            ) !==
              positive
        );

      if (
        negativeInput instanceof
          HTMLInputElement &&
        !negativeInput.checked
      ) {
        negativeInput.click();
      }
    }
  };

  const setPersonalizationState = (
    box,
    enabled
  ) => {
    const fields =
      getPersonalizationFields(
        box
      );

    const toggle =
      box.querySelector(
        '[data-lw-personalization-toggle]'
      );

    const toggleLabel =
      box.querySelector(
        '[data-lw-personalization-toggle-label]'
      );

    const offerSection =
      document.querySelector(
        '.lw-global-offer'
      );

    const productInformation =
      box.closest(
        '.product-information'
      ) ||
      document.querySelector(
        '.product-information'
      );

    box.dataset.enabled =
      enabled
        ? 'true'
        : 'false';

    box.dataset.lwPersonalizationSelected =
      enabled
        ? 'true'
        : 'false';

    box.classList.toggle(
      'lw-pilot-personalization--active',
      enabled
    );

    if (fields) {
      fields.hidden =
        !enabled;

      fields.setAttribute(
        'aria-hidden',
        enabled
          ? 'false'
          : 'true'
      );
    }

    if (
      toggle instanceof
        HTMLButtonElement
    ) {
      toggle.setAttribute(
        'aria-expanded',
        enabled
          ? 'true'
          : 'false'
      );
    }

    if (toggleLabel) {
      toggleLabel.textContent =
        enabled
          ? '✓ PERSONALISIERUNG AUSGEWÄHLT'
          : 'PRODUKT PERSONALISIEREN';
    }

    setPersonalizationControlsEnabled(
      box,
      enabled
    );

    if (productInformation) {
      productInformation.classList.toggle(
        'lw-personalization-active',
        enabled
      );
    }

    if (offerSection) {
      offerSection.hidden =
        enabled;

      offerSection.setAttribute(
        'aria-hidden',
        enabled
          ? 'true'
          : 'false'
      );
    }

    updateEncodedPersonalizationControls(
      enabled
    );

    updatePersonalizationSurchargeDisplay();

    refreshDisplayedPrice();
  };

  const activatePersonalization = (
    box
  ) => {
    if (
      usesPersonalizationVariants()
    ) {
      const switched =
        selectPersonalizationVariant(
          true
        );

      if (!switched) {
        return;
      }
    }

    setPersonalizationState(
      box,
      true
    );

    setLegacyPersonalizationChoice(
      box,
      true
    );

    const fields =
      getPersonalizationFields(
        box
      );

    window.requestAnimationFrame(
      () => {
        fields?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    );
  };

  const deactivatePersonalization = (
    box
  ) => {
    if (
      box.dataset
        .lwPersonalizationRequiredIncluded ===
      'true'
    ) {
      setPersonalizationState(
        box,
        true
      );
      return;
    }

    if (
      usesPersonalizationVariants()
    ) {
      const switched =
        selectPersonalizationVariant(
          false
        );

      if (!switched) {
        return;
      }
    }

    clearPersonalizationFields(
      box
    );

    setPersonalizationState(
      box,
      false
    );

    setLegacyPersonalizationChoice(
      box,
      false
    );

    box
      .querySelector(
        '[data-lw-personalization-toggle]'
      )
      ?.focus();
  };

  const updatePersonalization = () => {
    const box =
      getPersonalizationBox();

    if (!box) {
      const offerSection =
        document.querySelector(
          '.lw-global-offer'
        );

      if (offerSection) {
        offerSection.hidden =
          false;

        offerSection.setAttribute(
          'aria-hidden',
          'false'
        );
      }

      return;
    }

    const personalizationRequiredIncluded =
      box.dataset
        .lwPersonalizationRequiredIncluded ===
      'true';

    const selectedVariantState =
      getSelectedPersonalizationState();

    if (
      personalizationRequiredIncluded
    ) {
      if (
        usesPersonalizationVariants() &&
        selectedVariantState !== true
      ) {
        const switched =
          selectPersonalizationVariant(
            true
          );

        if (!switched) {
          console.warn(
            'LW Produkt: Die verpflichtende, im Preis enthaltene Personalisierungsvariante konnte nicht aktiviert werden.'
          );
        }
      }

      setPersonalizationState(
        box,
        true
      );

      return;
    }

    const enabled =
      selectedVariantState === null
        ? box.dataset
            .lwPersonalizationSelected ===
          'true'
        : selectedVariantState;

    setPersonalizationState(
      box,
      enabled
    );
  };

  const updateConditionalFileUpload = () => {
    const upload =
      document.querySelector(
        '[data-lw-conditional-file-upload]'
      );

    if (!upload) {
      return;
    }

    const fileInput =
      upload.querySelector(
        'input[type="file"]'
      );

    if (
      !(
        fileInput instanceof
        HTMLInputElement
      )
    ) {
      return;
    }

    const requiredValue =
      normalize(
        upload.dataset
          .lwUploadValue ||
        'mit Druck'
      );

    const printFieldset =
      document.querySelector(
        '.product-information .lw-print-fieldset'
      );

    const selected =
      printFieldset?.querySelector(
        'input:checked'
      );

    const showUpload =
      selected instanceof
        HTMLInputElement &&
      normalize(
        selected.value
      ) ===
        requiredValue;

    upload.hidden =
      !showUpload;

    upload.setAttribute(
      'aria-hidden',
      showUpload
        ? 'false'
        : 'true'
    );

    fileInput.disabled =
      !showUpload;

    if (
      !showUpload &&
      fileInput.value
    ) {
      fileInput.value =
        '';
    }
  };

  const getEndcapColorSelect = () => {
    const select =
      document.querySelector(
        '[data-lw-endcap-color]'
      );

    return (
      select instanceof
      HTMLSelectElement
        ? select
        : null
    );
  };

  const getEndcapError = () =>
    document.querySelector(
      '[data-lw-endcap-error]'
    );

  const updateEndcapColorValidity = (
    showError = false
  ) => {
    const select =
      getEndcapColorSelect();

    if (!select) {
      return true;
    }

    const valid =
      normalize(
        select.value
      ) !== '';

    select.setCustomValidity(
      valid
        ? ''
        : ENDCAP_ERROR_MESSAGE
    );

    select.setAttribute(
      'aria-invalid',
      valid
        ? 'false'
        : 'true'
    );

    const error =
      getEndcapError();

    if (error) {
      error.hidden =
        valid ||
        !showError;
    }

    return valid;
  };

  const validateEndcapColor = () => {
    const select =
      getEndcapColorSelect();

    if (!select) {
      return true;
    }

    const valid =
      updateEndcapColorValidity(
        true
      );

    if (valid) {
      return true;
    }

    select.focus({
      preventScroll: true,
    });

    select.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });

    if (
      typeof select.reportValidity ===
      'function'
    ) {
      select.reportValidity();
    }

    return false;
  };

  const parseLocalizedMoney = (
    value
  ) => {
    const text =
      (
        value ||
        ''
      )
        .replace(
          /\s/g,
          ''
        )
        .replace(
          /[^0-9,.-]/g,
          ''
        );

    if (!text) {
      return null;
    }

    const lastComma =
      text.lastIndexOf(',');

    const lastDot =
      text.lastIndexOf('.');

    let normalized =
      text;

    if (
      lastComma >
      lastDot
    ) {
      normalized =
        text
          .replace(
            /\./g,
            ''
          )
          .replace(
            ',',
            '.'
          );
    } else if (
      lastDot >
      lastComma
    ) {
      normalized =
        text.replace(
          /,/g,
          ''
        );
    }

    const numeric =
      Number(
        normalized
      );

    return Number.isFinite(
      numeric
    )
      ? numeric
      : null;
  };

  const getCurrentVariantBaseNetPrice = () => {
    const variant =
      getCurrentVariantData();

    if (!variant) {
      return null;
    }

    return toNetPrice(
      variant.price
    );
  };

  const captureBasePriceFromDisplay = () => {
    const priceContext =
      getPriceContext();

    const netTarget =
      priceContext?.querySelector(
        '[data-lw-net-price]'
      );

    if (!netTarget) {
      return null;
    }

    return parseLocalizedMoney(
      netTarget.textContent
    );
  };

  const renderDisplayedPrice = (
    baseNetPrice,
    currency
  ) => {
    if (
      !Number.isFinite(
        baseNetPrice
      )
    ) {
      return;
    }

    const priceContext =
      getPriceContext();

    if (!priceContext) {
      return;
    }

    const effectiveCurrency =
      currency ||
      priceContext.dataset
        .currency ||
      'EUR';

    const format =
      moneyFormatter(
        effectiveCurrency
      );

    const surcharge =
      getPersonalizationSurcharge();

    const displayedNet =
      baseNetPrice +
      surcharge;

    const pricePrefix =
      priceContext.querySelector(
        '[data-lw-price-prefix]'
      );

    if (pricePrefix) {
      pricePrefix.textContent =
        '';
    }

    const netTarget =
      priceContext.querySelector(
        '[data-lw-net-price]'
      );

    if (netTarget) {
      netTarget.textContent =
        format.format(
          displayedNet
        );
    }

    const stickyPrefix =
      document.querySelector(
        '[data-lw-sticky-price-prefix]'
      );

    if (stickyPrefix) {
      stickyPrefix.textContent =
        '';
    }

    const stickyTarget =
      document.querySelector(
        '[data-lw-sticky-net-price]'
      );

    if (stickyTarget) {
      stickyTarget.textContent =
        format.format(
          displayedNet
        );
    }
  };

  const refreshDisplayedPrice = () => {
    if (
      usesPersonalizationVariants()
    ) {
      const selectedVariantNetPrice =
        getCurrentVariantBaseNetPrice();

      if (
        Number.isFinite(
          selectedVariantNetPrice
        )
      ) {
        currentBaseNetPrice =
          selectedVariantNetPrice;
      }
    }

    if (
      !Number.isFinite(
        currentBaseNetPrice
      )
    ) {
      currentBaseNetPrice =
        getCurrentVariantBaseNetPrice();

      if (
        !Number.isFinite(
          currentBaseNetPrice
        )
      ) {
        currentBaseNetPrice =
          captureBasePriceFromDisplay();
      }
    }

    if (
      !Number.isFinite(
        currentBaseNetPrice
      )
    ) {
      return;
    }

    renderDisplayedPrice(
      currentBaseNetPrice
    );
  };

  const updateDisplayedPrice = (
    variant
  ) => {
    if (
      !variant?.price?.amount
    ) {
      return;
    }

    const net =
      toNetPrice(
        variant.price.amount
      );

    if (
      !Number.isFinite(
        net
      )
    ) {
      return;
    }

    currentBaseNetPrice =
      net;

    renderDisplayedPrice(
      currentBaseNetPrice,
      variant.price
        .currencyCode
    );
  };

  const updateProductUI = () => {
    classifyVariantFields();
    enhanceSetCards();
    updatePersonalization();
    updatePersonalizationSurchargeDisplay();
    updateConditionalFileUpload();
    updateEndcapColorValidity(
      false
    );
    refreshDisplayedPrice();
  };

  const initProduct = () => {
    if (
      !document.body.classList.contains(
        BODY_CLASS
      )
    ) {
      return;
    }

    updateProductUI();

    window.requestAnimationFrame(() => {
      syncBoatFontMedia();
    });
  };

  document.addEventListener(
    'change',
    (event) => {
      if (
        !document.body.classList.contains(
          BODY_CLASS
        )
      ) {
        return;
      }

      if (
        event.target instanceof
          HTMLSelectElement &&
        event.target.matches(
          '[data-lw-endcap-color]'
        )
      ) {
        updateEndcapColorValidity(
          false
        );
      }

      if (
        !(
          event.target instanceof
          Element
        ) ||
        !event.target.closest(
          'variant-picker'
        )
      ) {
        return;
      }

      if (
        event.isTrusted
      ) {
        userHasSelectedVariant =
          true;
      }

      const changedOptionName =
        event.target instanceof HTMLInputElement
          ? event.target.getAttribute('data-option-name') || ''
          : event.target instanceof HTMLSelectElement
            ? event.target.selectedOptions?.[0]?.getAttribute('data-option-name') || ''
            : '';

      const changedFontValue =
        isFontOptionName(changedOptionName)
          ? String(event.target.value || '')
          : '';

      window.requestAnimationFrame(
        () => {
          classifyVariantFields();
          updatePersonalization();
          updatePersonalizationSurchargeDisplay();
          updateConditionalFileUpload();
          updateEndcapColorValidity(
            false
          );

          if (changedFontValue) {
            showBoatFontMedia(
              changedFontValue
            );
          }
        }
      );
    }
  );

  document.addEventListener(
    'invalid',
    (event) => {
      if (
        !document.body.classList.contains(
          BODY_CLASS
        )
      ) {
        return;
      }

      if (
        !(
          event.target instanceof
          HTMLSelectElement
        ) ||
        !event.target.matches(
          '[data-lw-endcap-color]'
        )
      ) {
        return;
      }

      updateEndcapColorValidity(
        true
      );
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (
        !document.body.classList.contains(
          BODY_CLASS
        )
      ) {
        return;
      }

      const select =
        getEndcapColorSelect();

      if (!select) {
        return;
      }

      const formId =
        select.getAttribute(
          'form'
        );

      if (
        formId &&
        event.target instanceof
          HTMLFormElement &&
        event.target.id !==
          formId
      ) {
        return;
      }

      if (
        validateEndcapColor()
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (
        !document.body.classList.contains(
          BODY_CLASS
        )
      ) {
        return;
      }

      if (
        event.target instanceof
          Element
      ) {
        const personalizationToggle =
          event.target.closest(
            '[data-lw-personalization-toggle]'
          );

        if (
          personalizationToggle
        ) {
          const box =
            personalizationToggle.closest(
              '[data-lw-personalization]'
            );

          if (box) {
            event.preventDefault();

            if (
              box.dataset.enabled ===
              'true'
            ) {
              deactivatePersonalization(
                box
              );
            } else {
              activatePersonalization(
                box
              );
            }
          }

          return;
        }

        const personalizationRemove =
          event.target.closest(
            '[data-lw-personalization-remove]'
          );

        if (
          personalizationRemove
        ) {
          const box =
            personalizationRemove.closest(
              '[data-lw-personalization]'
            );

          if (box) {
            event.preventDefault();

            deactivatePersonalization(
              box
            );
          }

          return;
        }
      }

      const select =
        getEndcapColorSelect();

      if (!select) {
        return;
      }

      const formId =
        select.getAttribute(
          'form'
        );

      const form =
        formId
          ? document.getElementById(
              formId
            )
          : null;

      const path =
        typeof event.composedPath ===
        'function'
          ? event.composedPath()
          : [event.target];

      const purchaseControl =
        path.find(
          (node) => {
            if (
              !(
                node instanceof
                Element
              )
            ) {
              return false;
            }

            return (
              node.matches(
                'button[name="add"]'
              ) ||
              node.matches(
                'button[type="submit"]'
              ) ||
              node.matches(
                'input[type="submit"]'
              ) ||
              node.matches(
                '.shopify-payment-button__button'
              ) ||
              node.matches(
                'shopify-accelerated-checkout'
              ) ||
              node.matches(
                'shopify-accelerated-checkout-cart'
              )
            );
          }
        );

      if (
        !purchaseControl
      ) {
        return;
      }

      if (
        form &&
        !form.contains(
          purchaseControl
        )
      ) {
        return;
      }

      if (
        validateEndcapColor()
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    EVENT_NAME,
    (event) => {
      if (
        !document.body.classList.contains(
          BODY_CLASS
        )
      ) {
        return;
      }

      if (
        !event?.promise ||
        typeof event.promise.then !==
          'function'
      ) {
        return;
      }

      event.promise
        .then(
          ({ variant }) => {
            window.requestAnimationFrame(
              () => {
                if (
                  variant
                ) {
                  updateDisplayedPrice(
                    variant
                  );
                }

                updateProductUI();
                syncBoatFontMedia();
              }
            );
          }
        )
        .catch(
          (error) => {
            if (
              error?.name !==
              'AbortError'
            ) {
              console.warn(
                'LW Produkt: Variantenaktualisierung fehlgeschlagen.',
                error
              );
            }
          }
        );
    }
  );

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initProduct,
      {
        once: true,
      }
    );
  } else {
    initProduct();
  }

  document.addEventListener(
    'shopify:section:load',
    initProduct
  );
})();